import { useQuery, useMutation } from 'react-query'
import { AuthRepository } from 'repository/auth'
import { SignupData, LoginData, RequestPasswordParams, RecoverPasswordParams } from 'models/auth'

export const useLogin = () => {
  return useMutation((data: LoginData) => AuthRepository.login(data))
}

export const useLogout = () => {
  return useMutation(AuthRepository.logout)
}

export const useFetchMe = (options: any) => {
  const { status, data, error } = useQuery('me', AuthRepository.me, options)

  return {
    status,
    user: data,
    error,
  }
}

export const useRequestPassword = () => {
  return useMutation((data: RequestPasswordParams) => AuthRepository.requestPasswordRecovery(data))
}

export const useRecoverPassword = (uuid: string) => {
  return useMutation((data: RecoverPasswordParams) => AuthRepository.recoverPassword(data, uuid))
}

export const useSignup = () => {
  return useMutation((data: SignupData) => AuthRepository.signup(data))
}

export const useFetchInvitation = (invitationId: string, options?: any) => {
  const { status, data, error } = useQuery(
    !!invitationId && ['invitation', { invitationId }],
    () => AuthRepository.fetchInvitation(invitationId),
    options,
  )

  return {
    status,
    user: data,
    error,
  }
}

export const useCompleteInvitation = (invitationId: string, email: string) => {
  return useMutation((data: Partial<SignupData>) => {
    return AuthRepository.completeInvitation(invitationId, email, data)
  })
}
